
export const buildJsonMarked = (data: object): string => {
  const str = JSON.stringify(data, null, '  ')
  return [
    '```json',
    str,
    '```',
  ].join('\n')
}
